import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: '¿Cómo recibo el e-book?',
  answer: 'Después del pago, verá un enlace de descarga y también recibirá el enlace por correo. Revise su carpeta de spam o promociones por si acaso.'
}, {
  question: '¿En qué formato viene?',
  answer: 'El e-book viene en formato PDF, optimizado para leerse en celular, tablet o computadora.'
}, {
  question: '¿Puedo imprimirlo?',
  answer: 'Sí, puede imprimirlo para su uso personal.'
}, {
  question: '¿Puedo compartirlo?',
  answer: 'No. La compra es para uso personal exclusivamente. No se permite redistribuir ni compartir el archivo.'
}, {
  question: '¿Ofrecen reembolsos?',
  answer: 'Por ser un producto digital descargable, las ventas son finales. Si existe un problema técnico con su descarga, contáctenos y le ayudaremos inmediatamente.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-24 px-6 md:px-12 bg-cream-50 w-full flex justify-center" data-id="element-40">
      <div className="max-w-3xl w-full" data-id="element-41">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-12" data-id="element-42">
          <h2 className="text-3xl md:text-4xl font-playfair text-bark-900 mb-4" data-id="element-43">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-44">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-white rounded-lg border border-sage-200 overflow-hidden" data-id="element-45">
              <button onClick={() => toggleFAQ(index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" aria-expanded={openIndex === index} data-id="element-46">
                <span className="font-playfair font-semibold text-lg text-bark-900" data-id="element-47">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-sage-500 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-48" />
              </button>

              <AnimatePresence data-id="element-49">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-50">
                    <div className="px-6 pb-5 pt-0 text-bark-700 font-lato text-base" data-id="element-51">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}